module.exports = Swiper;


//////////////////
// WEBPACK FOOTER
// external "Swiper"
// module id = 8
// module chunks = 0